export enum OpenClosedFilter {
  RESOLVED = 'resolved',
  UNRESOLVED = 'unresolved'
}
